module.exports = __webpack_public_path__ + "img/xuqiucaigou.d64fc68f.png";